export function blankGetters() {
  return;
}
